import { render, staticRenderFns } from "./previewSet.vue?vue&type=template&id=ba056458"
import script from "./previewSet.vue?vue&type=script&lang=js"
export * from "./previewSet.vue?vue&type=script&lang=js"
import style0 from "./previewSet.vue?vue&type=style&index=0&id=ba056458&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports